import Dropdown, { DropdownProps } from './UI/Dropdown'
import Suspenseful from './Suspenseful'
import sortBy from 'lib/utils/sort-by'
import { RecordIdentity } from '@orbit/records';
import { Resource } from 'resources/Resource';

export type ResourceItemSelectorProps<T extends RecordIdentity> = Omit<DropdownProps<T>, "collection"> & {
  resource: Resource<T[]>;
  sortSpec?: ((a: T, b: T) => number) | null;
  filterSpec?: (item: T) => boolean;
}

function ResourceItemSelector<T extends RecordIdentity>({ resource, sortSpec = null, filterSpec, ...props }: ResourceItemSelectorProps<T>) {
  if (!resource) return null
  let collection = resource.get()
  if (!collection) return null
  if(filterSpec) {
    collection = collection.filter(filterSpec)
  }
  if(sortSpec !== null) {
    collection = sortBy(collection, sortSpec)
  }

  return (
    <Dropdown
      collection={collection}
      {...props}
    />
  )
}

export default function ResourceItemSelectorWrapper<T extends RecordIdentity>(props: ResourceItemSelectorProps<T>) {
  const { filterSpec, sortSpec, ...otherProps } = props

  return (
    <Suspenseful
      component={ResourceItemSelector<T>}
      fallback={
        <Dropdown label={props.label} loading={true} collection={[]} {...otherProps}/>
      }
      filterSpec={filterSpec}
      sortSpec={sortSpec}
      {...otherProps}
    />
  )
}
